import { Chip, alpha, makeStyles } from '@material-ui/core';

import { getTypeOrNull } from '@spotify/confidence-graphql';
import { useIdentity } from '@spotify/plugin-confidence-iam-react';

const useStyles = makeStyles(theme => ({
  chip: {
    pointerEvents: 'none',
    verticalAlign: 'baseline',
    backgroundColor: alpha(theme.palette.background.default, 0.5),
    // Need these because the Backstage themes have margins on chips
    marginRight: 0,
    marginBottom: 0,
  },
}));

/**
 * Props for {@link MentionChip} component.
 */
export interface MentionChipProps {
  // The fallback name of the person being mention.  This is used if the user
  // is not found.
  displayName: string;

  // Resource name of the user being mentions.
  name: string;
}

/**
 * Component for showing a mention chip with the user's name and avatar.
 * It falls back to the display name if the user is not found.
 */
export const MentionChip = ({
  displayName,
  name,
}: {
  displayName: string;
  name: string;
}) => {
  const classes = useStyles();
  const { identity } = useIdentity({ name });
  const user = getTypeOrNull(identity?.user);

  return (
    <Chip
      component="span"
      size="small"
      className={classes.chip}
      label={`@${user?.fullName ?? identity?.displayName ?? displayName}`}
    />
  );
};
